import React from 'react';
import styles from './Landing.scss';

const UserAgreement = () => (
  <div className={styles.Landing}>
    <h1>ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ</h1>

    <p>
      Настоящим ООО «НЕДВЕКС» (ИНН: 2318043183 ОГРН: 1162366056830) в лице Генерального директора
      Хлудневой Юлии Артуровны, действующего на основании Устава (далее – Правообладатель)
      предлагает любому дееспособному физическому лицу, и (или) индивидуальному предпринимателю, и
      (или) юридическому лицу (далее – Пользователю), право использования сервисов NEDVEX.
    </p>

    <p>
      В соответствии с настоящей публичной офертой Правообладатель предлагает Пользователю услуги по
      использованию Сервиса в качестве информационного сервиса о недвижимости в коммерческих целях и
      не коммерческих целях.
    </p>

    <p>
      Объем Ваших прав (возможностей) на использование Сервисов NEDVEX зависит от акцептованного
      Тарифа.
    </p>

    <p>
      Настоящий договор признается публичной офертой. В соответствии со статьей 438 Гражданского
      Кодекса Российской Федерации (ГК РФ), безусловным принятием (акцептом) условий настоящей
      публичной оферты считается осуществление Пользователем регистрации в Сервисе путем заполнения
      регистрационной формы и выражения согласия с условиями настоящей публичной оферты, а также
      использование функционала Сервиса.
    </p>

    <p>
      Настоящая публичная оферта, заключаемая путем акцепта, не требует двустороннего подписания и
      действительна в электронном виде. Использование Сервиса Пользователем означает, что
      Пользователь принимает и обязуется соблюдать все нижеприведенные условия публичной оферты.
    </p>

    <h2>СТОРОНЫ ЗАКЛЮЧАЮТ ПУБЛИЧНУЮ ОФЕРТУ НА СЛЕДУЮЩИХ УСЛОВИЯХ:</h2>

    <h3>1. Термины и определения</h3>

    <p>
      1.1. В целях настоящего Соглашения нижеприведенные термины используются в следующем значении:
    </p>

    <p>
      1.1.1. <strong>Сайт Nedvex (или сайт) </strong>представленная в сети «Интернет» совокупность
      визуально воспринимаемых страниц и элементов управления доступом к программно-информационным
      средствам, размещенным по сетевому адресу (доменному имени): https://app.nedvex.ru/, включая
      все уровни указанных доменов, как функционирующих на дату заключения настоящего Соглашения,
      так и запускаемых и вводимых в эксплуатацию в течение всего срока его действия.
    </p>

    <p>
      1.1.2. <strong>Программы для ЭВМ NEDVEX (или Программы для ЭВМ/Приложения) </strong>–
      представленные в объективной форме совокупности данных и команд, предназначенных для
      функционирования ЭВМ и других персональных устройств, в том числе визуально представленные в
      виде внешних интерфейсов, в целях систематизации и управления Базой данных NEDVEX, а также
      получения иных результатов, обеспечиваемых посредством использования конкретных данных и
      команд в соответствии с их функциональным предназначением, в пределах предусмотренных
      настоящим Соглашением. Исключительные права на Программы для ЭВМ на территории РФ принадлежат
      Правообладателю защищены и зарегистрированы в Федеральной службе по интеллектуальной
      собственности (Роспатенте).
    </p>

    <p>
      1.1.3. <strong>База данных NEDVEX (или База данных) </strong>– представленная в объективной
      форме совокупность текстовых и графических материалов об объектах недвижимого имущества,
      содержащаяся на серверах Правообладателя и систематизированная с помощью Программ для ЭВМ
      NEDVEX таким образом, что эти материалы могут быть найдены и обработаны Пользователем и
      третьими лицами с помощью ЭВМ. Исключительные права на Базу данных NEDVEX на территории РФ
      принадлежат Правообладателю защищены и зарегистрированы в Федеральной службе по
      интеллектуальной собственности (Роспатенте).
    </p>

    <p>
      1.1.4. <strong>Сервис (Сервисы NEDVEX) </strong>– ресурс, состоящий из совокупности (а)
      Программ для ЭВМ NEDVEX, (б) Базы данных NEDVEX и (в) Сайта Nedvex.
    </p>

    <p>
      1.1.5. <strong>Пользователь </strong>– зарегистрированное в Сервисе дееспособное физическое
      лицо или правоспособное юридическое лицо, который прошел процедуру регистрации и верификации в
      Сервисе, исключительно способом регламентированным настоящим Соглашением и другими
      документами, которые регулируют взаимоотношение между Пользователями и Правообладателем.
    </p>

    <p>
      1.1.6. <strong>Личный кабинет </strong>– совокупность защищенных страниц в Сервисе,
      создаваемых при регистрации Пользователя, на которых Пользователь может использовать
      функционал Сервиса. Доступ к Личному кабинету осуществляется Пользователя посредством ввода
      Учетной информации.
    </p>

    <p>
      1.1.7. <strong>Услуги </strong>– предоставляемые Правообладателем Услуги посредством Сервиса.
    </p>

    <p>
      1.1.8. <strong>Учетная запись/профиль </strong>– единая персональная часть Сервиса,
      обеспечивающая функциональные возможности: (а) индивидуализации Пользователя среди других
      Пользователей Сервиса; (б) удаленного доступа к Программам для ЭВМ NEDVEX и Базе данных NEDVEX
      для реализации Пользователем приобретаемых прав использования посредствам их воспроизведения
      или без такового; (в) обмена данными, информацией и сообщениями между Пользователем и
      Правообладателем; (г) осуществления Правообладателем контроля за ходом реализации
      Пользователем права использования Программ для ЭВМ NEDVEX и Базы данных NEDVEX; (д)
      определения размера уплаченного Правообладателю вознаграждения Правообладателю по настоящему
      Соглашению. Доступ к учетной записи/профилю и его функциональным возможностям предоставляется
      Пользователю после его регистрации в Сервисе.
    </p>

    <p>
      1.1.9. <strong>Правообладатель </strong>– ООО "НЕДВЕКС", ИНН 2318043183, КПП 231801001, ОГРН
      1162366056830. Адрес: 354207, Краснодарский край, город Сочи, Лазаревский район, ул. Летняя,
      строение 15/2. ООО «НЕДВЕКС» является правообладателем исключительных прав на Сервис.
    </p>

    <p>
      1.1.10. <strong>Тариф </strong>– тарифный план, выбранный Пользователем из Списка тарифов с
      использованием своей учетной записи и оплаченный им. Список тарифов расположен по сетевому
      адресу (доменному имени): <a href="https://app.nedvex.ru/">https://app.nedvex.ru/</a>.
      Указанные цены являются ориентировочными, окончательный размер вознаграждения определяется в
      момент оформлении заявки на приобретение тарифа. Список тарифов является информационной
      системой, обеспечивающей доступность такой информации в сети Интернет по сетевому адресу
      (доменному имени): <a href="https://app.nedvex.ru/">https://app.nedvex.ru/</a>.
    </p>

    <p>
      1.1.11. <strong>Стороны </strong>– Пользователь и Правообладатель по настоящему Соглашению.
    </p>

    <p>
      1.1.12. <strong>Соглашение </strong>– текст настоящего Пользовательского соглашения (Публичная
      оферта на заключение договора оказания услуг посредством сервиса NEDVEX) между Пользователем и
      Правообладателем, содержащий все необходимые и существенные условия договора о предоставлении
      прав использования Программ для ЭВМ NEDVEX и Базы данных NEDVEX.
    </p>

    <p>
      1.1.13. <strong>Верификация </strong>– процедура, позволяющая установить принадлежность
      конкретного номера телефона и (или) электронной почты Пользователю, посредством которой
      происходит регистрация в Сервисе.
    </p>

    <p>
      1.1.14. <strong>Демо-версия </strong>– право использования Программ для ЭВМ NEDVEX и Базы
      данных NEDVEX, ограниченное по сроку и предусмотренными Соглашением пределами, предназначенное
      исключительно для ознакомления с функциональными возможностями отдельных Программ для ЭВМ
      NEDVEX и Базы данных NEDVEX.
    </p>

    <p>
      1.1.15. <strong>Соглашение </strong>– текст настоящий правил пользования.
    </p>

    <p>
      1.2. В Условиях могут быть использованы термины, не определенные в п. 1.1 Соглашения. В этом
      случае толкование такого термина производится в соответствии с текстом Условий. В случае
      отсутствия однозначного толкования термина в тексте Условий следует руководствоваться
      толкованием термина, определенным законодательством Российской Федерации, затем — сложившимся
      (общеупотребимым) в сети Интернет.
    </p>

    <h3>2. Предмет настоящего соглашения</h3>

    <p>
      2.1. Настоящее Соглашение разработано Правообладателем и определяет условия использования
      Сервиса, а также права и обязанности Пользователей и Правообладателя. Правила распространяются
      также на отношения, связанные с правами и интересами третьих лиц, не являющимися
      Пользователями Сервиса, но чьи права и интересы могут быть затронуты в результате действий
      Пользователей Сервиса.
    </p>

    <p>
      2.2. По настоящему Соглашению Правообладатель предоставляет Пользователю право использования
      Сервиса в установленных Соглашением пределах, а Пользователь обязуется за это выплатить
      вознаграждение в размере, установленном соответствующим Тарифом. К соглашению между
      Пользователем и Правообладателем относятся любые иные правила (специальные документы),
      регламентирующие порядок и характер предоставления доступа к использованию Сервиса,
      размещенных в свободном доступе в сети Интернет по сетевому адресу (доменному имени):{' '}
      <a href="https://app.nedvex.ru/">https://app.nedvex.ru/</a>.
    </p>

    <p>2.3. В рамках настоящего Соглашения Правообладатель предоставляет Пользователю услуги:</p>

    <p>
      2.3.1. доступа к базе данных объектов недвижимости с целью поиска и просмотра информации о
      них;
    </p>

    <p>
      2.3.2. формирование подборки объектов недвижимости, создание и отправка активной ссылку с
      возможностью просмотра незарегистрированным пользователям;
    </p>

    <p>2.3.3. формирование информации об объектах недвижимости;</p>

    <p>2.3.4. иные виды услуг, доступные Пользователю в рамках Соглашения.</p>

    <p>
      2.4. Акцепт настоящего Соглашения осуществляется путем принятия Пользователем условий
      Соглашения при регистрации в Сервисе или с момента начала использования Пользователем Сервиса
      без регистрации в той мере, в какой это допустимо функциональными возможностями Сервиса.
      Регистрация в Сервисе без подтверждения согласия с настоящим Соглашением технически
      невозможна. Акцепт настоящего Соглашения означает, что Пользователь гарантирует, что по закону
      его юрисдикции он обладает достаточной дееспособностью для заключения Соглашения.
    </p>

    <p>
      2.5. Настоящее Соглашение является открытым и общедоступным документом. Действующая редакция
      Соглашения располагается в сети Интернет по сетевому адресу (доменному имени):{' '}
      <a href="https://app.nedvex.ru/">https://app.nedvex.ru/</a>. Пользователь обязуется регулярно
      самостоятельно проверять условия настоящего Соглашения на предмет их изменения и/или
      дополнения. Продолжение использования Программ для ЭВМ и/или Базы данных NEDVEX Пользователем
      после внесения изменений и/или дополнений в настоящее Соглашение означает безоговорочное
      принятие и согласие (акцепт) Пользователем с такими изменениями и/или дополнениями.
    </p>

    <p>
      2.6. Настоящее Соглашение может быть изменены Правообладателем в любое время без какого-либо
      уведомления об этом Пользователя. Новая редакция Правил вступает в силу с момента их
      размещения, если в тексте Правил не указана иная дата вступления в силу новых условий.
    </p>

    <p>
      2.7. Копируя Программу, устанавливая её на свое мобильное устройство или используя Программу
      любым образом, Пользователь выражает свое полное и безоговорочное согласие со всеми условиями
      Соглашения.
    </p>

    <p>
      2.8. Использование Программы разрешается только на условиях настоящего Соглашения. Если
      Пользователь не принимает условия Соглашения в полном объеме, Пользователь не имеет права
      использовать Программу в каких-либо целях. Использование Программы с нарушением
      (невыполнением) какого-либо из условий Соглашения – запрещено.
    </p>

    <p>
      2.9. Использование Программы на условиях и способами, не предусмотренными настоящим
      Соглашением, возможно только на основании отдельного соглашения с Правообладателем.
    </p>

    <p>
      2.10. Для того чтобы воспользоваться некоторыми отдельными функциями Сервиса, Пользователю
      необходимо пройти процедуру регистрации, в результате которой для Пользователя будет создана
      уникальная учетная запись. Пользователь вправе иметь неограниченное число профилей в Сервисе.
      Создание нескольких профилей для получения выгоды путем введения в заблуждение является
      нарушением настоящего Соглашения и может привести к немедленной блокировке всех профилей
      Пользователя, а также к невозможности применения всех указанных/использованных номеров
      телефонов/электронных адресов/банковских карт такого Пользователя в Сервисе в дальнейшем.
    </p>

    <p>2.11. Порядок регистрации в Сервисе:</p>

    <p>
      2.11.1. Для регистрации Пользователь обязуется предоставить достоверную и полную информацию о
      себе по вопросам, предлагаемым в форме регистрации, и поддерживать эту информацию в актуальном
      состоянии. Если Пользователь предоставляет неверную информацию или у Правообладателя есть
      основания полагать, что предоставленная Пользователем информация неполная и/или недостоверна,
      Правообладатель имеет право по своему усмотрению заблокировать либо удалить учетную запись
      Пользователя и отказать Пользователю в использовании своих сервисов (либо их отдельных
      функций). Правообладатель имеет право дополнительно запросить документы для регистрации
      Пользователя в Сервисе если имеются обоснованные сомнения в представленных ранее документах и
      (или) информации.
    </p>

    <p>
      2.11.2. Правообладатель оставляет за собой право в любой момент потребовать от Пользователя
      подтверждения данных, указанных при регистрации в учетной записи Пользователя в Сервисе (в том
      числе данных банковской карты, привязанной Пользователем к Сервису) и содержащих информацию о
      Пользователе. Для целей проверки заявленных Пользователем данных Правообладатель вправе
      запросить подтверждающие документы, непредоставление которых, по усмотрению Правообладателя,
      может быть приравнено к предоставлению недостоверной информации. В случае если данные
      Пользователя, указанные в предоставленных им документах, не соответствуют данным, указанным
      при регистрации, а также в случае, когда данные, указанные при регистрации, не позволяют
      идентифицировать пользователя, Правообладатель вправе отказать Пользователю в доступе к
      учетной записи и использовании Сервиса.
    </p>

    <p>
      2.11.3. Средством для доступа к учетной записи будет являться: номер мобильного телефона
      Пользователя и одноразовый пароль, высылаемый Правообладателем на номер мобильного телефона по
      СМС (SMS) и/или последние четыре цифры номера телефона входящего звонка на номер Пользователя
      направленного Правообладателем и/или иным способом предусмотренным функционалом сервиса.
    </p>

    <p>
      2.11.4. Пользователю предоставляет перечень функциональных возможностей Сервиса в рамках
      выбранного им Тарифа.
    </p>

    <p>
      2.11.5. Пользователь самостоятельно несет ответственность за безопасность (в том числе
      устойчивость к угадыванию) и сохранность выбранных им средств для доступа к Учетной записи, а
      также самостоятельно обеспечивает их конфиденциальность.
    </p>

    <p>
      2.11.6. Пользователь самостоятельно несет ответственность за все действия в рамках Учетной
      записи Пользователя. Все действия в рамках Учетной записи считаются произведенными самим
      Пользователем.
    </p>

    <p>
      2.11.7. Пользователь обязан немедленно уведомить Правообладателя о любом случае
      несанкционированного (не разрешенного Пользователем) доступа к Сервису с использованием
      Учетной записи Пользователя и/или о любом нарушении (подозрениях о нарушении)
      конфиденциальности своих средств доступа к Сервису. Правообладатель не отвечает за возможную
      потерю или порчу данных, а также другие последствия любого характера, которые могут произойти
      из-за нарушения Пользователем положений настоящего Соглашения.
    </p>

    <p>
      2.11.8. Правообладатель вправе заблокировать или удалить учетную запись Пользователя, а также
      запретить доступ с использованием какой-либо учетной записи к определенным функциональным
      возможностям Сервиса, и удалить любой контент без объяснения причин, в том числе в случае
      нарушения Пользователем условий Соглашения, а также в случае неиспользования Сервиса, если
      Пользователь не пользовался Сервисом более 12 месяцев.
    </p>

    <p>
      2.12. Используя Сервис, Пользователь дает свое согласие на получение сообщений рекламного
      характера. Пользователь вправе отказаться от получения сообщений рекламного характера путем
      использования соответствующего функционала Сервиса или следуя инструкциям, указанным в
      полученном сообщении рекламного характера.
    </p>

    <p>
      2.13. Правообладатель оставляет за собой право на свое усмотрение ограничить доступ
      Пользователя к Сервису (к определенным функциям Сервиса, если это возможно технологически) с
      использованием его учетной записи или полностью заблокировать учетную запись Пользователя при
      неоднократном нарушении условий Соглашения, либо применить к Пользователю иные меры с целью
      соблюдения требований законодательства или прав и законных интересов третьих лиц.
    </p>

    <p>
      2.14. Используя Сервис, Пользователь дает согласие Правообладателю и его аффилированным лицам
      на обработку персональной информации Пользователя, как этот термин определен в Политике
      конфиденциальности, для целей предоставления Сервиса, включая передачу Правообладателю
      персональной информации для указанных целей партнерам Правообладателя, равно как и получение
      такой информации от указанных лиц для тех же целей, а также для целей, предусмотренных
      законом, в том числе для целей осуществления прав и законных интересов Правообладателя и
      третьих лиц. Правообладатель передает лишь ту персональную информацию Пользователя, которая
      необходима для указанной цели. Обработка Правообладателем персональной информации
      Пользователя, а также иной информации, загружаемой, передаваемой и получаемой Пользователем
      посредством Сервиса, осуществляется на условиях Политики конфиденциальности, размещенной в
      сети Интернет по адресу <a href="https://app.nedvex.ru/">https://app.nedvex.ru/</a>, в части,
      не противоречащей Соглашению.
    </p>

    <p>
      2.14.1. Используя Сервис, Пользователь тем самым свободно, своей волей и в своем интересе
      предоставляет свои персональные данные Правообладателю для их обработки.
    </p>

    <p>
      2.14.2. Под обработкой персональных данных понимаются предусмотренные Федеральным законом от
      27.07.2006 г. № 152-ФЗ «О персональных данных» действия или совокупность действий, совершаемых
      с использованием средств автоматизации или без использования таких средств с персональными
      данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление,
      изменение), извлечение, использование, передачу (распространение, предоставление, доступ)
      удаление, уничтожение персональных данных.
    </p>

    <p>
      2.14.3. Обработка персональных данных, предоставляемых Пользователем при регистрации Учетной
      записи, осуществляется в соответствии с условиями Политики конфиденциальности.
    </p>

    <p>
      2.15. Пользователь настоящим уведомлен, понимает и соглашается с тем, что при использовании
      Сервиса для целей предоставления Пользователю функциональных возможностей Сервиса
      Правообладателю в автоматическом режиме передается следующая информация: Версия браузера, IP
      address, тип операционной системы устройства Пользователя, статистика использования функций
      Сервиса, данные местонахождения устройства (если применимо), история поисковых запросов, а
      также иная техническая информация, собираемая и обрабатываемая в рамках Политики
      конфиденциальности.
      <br />
      <br />
      Правообладатель имеет право распоряжаться статистической информацией, связанной с
      функционированием Сервиса.
    </p>

    <p>
      2.16. Для развития, оптимизации и внедрения нового функционала Сервиса, а также в целях
      информирования Пользователей о своих услугах, продвижения услуг, проведения опросов, получения
      Пользователем персонализированной (таргетированной) рекламы, контроля маркетинговых акций,
      клиентской поддержки, контроля удовлетворенности Пользователя и качества услуг, проверки,
      исследования и анализа таких данных Пользователь при оформлении бронирования, соглашается и
      поручает Правообладателю осуществлять, а также поручать аффилированным лицам и партнерам
      осуществлять с соблюдением применимого законодательства обработку данных, в т.ч. результатов
      автоматизированной обработки таких данных в виде целочисленных и/или текстовых значений и
      идентификаторов, их передачу аффилированным лицам и/или партнерам во исполнение такого
      поручения на обработку, а также осуществлять сбор (получение) данных Пользователя и иных
      связанных с Пользователем данных от аффилированных лиц и/или партнеров.
    </p>

    <p>
      2.17. Настоящее Соглашение может быть изменено Правообладателем в любое время без какого-либо
      уведомления об этом Пользователя. Новая редакция Правил вступает в силу с момента её
      размещения на Сайте, если в тексте Правил не указана иная дата вступления в силу новых
      условий.
    </p>

    <p>
      2.18. Пользователь берет на себя обязательства по оплате Услуг, согласно выбранному тарифу,
      описание и стоимость которого указана в Сервисе.
    </p>

    <p>
      2.19. Правообладатель обязуется предоставить Пользователю возможность использовать Сервис на
      условиях, описанных в настоящем Соглашении.
    </p>

    <p>
      2.20. Для использования всех возможностей Сервиса, Пользователь обязан иметь верифицированную
      Учетную запись в Сервисе.
    </p>

    <h3>3. ОПЛАТА УСЛУГ</h3>

    <p>
      3.1. Оплата услуг Пользователем производиться после верификации учетной записи
      Правообладателем.
    </p>

    <p>
      3.2. В рамках выбранного Пользователем тарифа предоставляется соответствующий объем услуг
      (функциональных возможностей) и период, на который он предоставляется.
    </p>

    <p>
      3.3. Оплата может быть произведена (при функциональной возможности) Пользователем безналичным
      способом на сайте платежной системы и (или) иным способом предложенным в рамках работы
      Сервиса.
    </p>

    <p>
      3.4. Пользователь выбирает Тариф и переходит на сайте платежной системы для оплаты. После
      успешной оплаты на сайте соответствующей платежной системы Пользователь переадресовывается в
      Сервис, где ему предоставляется информация, подтверждающая факт оплаты.
    </p>

    <p>
      3.5. Пользователь понимает и соглашается, что все действия, совершенные в рамках Сервиса с
      использованием подтвержденного им номера мобильного телефона, в том числе по безналичной
      оплате с использованием Привязанной банковской карты, считаются совершенными Пользователем.
    </p>

    <p>
      3.6. Пользователю также может быть предоставлена возможность оплаты по выставляемым
      Правообладателям счетам, с указанием соответствующего тарифа и его стоимости, а также иными
      способами в рамках отдельного соглашения с Правообладателем.
    </p>

    <p>
      3.7. Пользователь принимает подтверждение оплаты – письмо с копией подтверждения оплаты,
      которые высылаются на электронный адрес, указанный Пользователем при регистрации в Сервисе.
    </p>

    <p>
      3.8. Правообладатель не несет ответственности перед Пользователем за действие/бездействие
      платежной системы (банка) при оплате за Тариф и иных услуг. Правообладатель не несет
      ответственности перед пользователем за сохранность данных о его банковской карте, введенных
      при проведении платежа на сайте платежной системы.
    </p>

    <p>
      3.9. Правообладатель оставляет за собой право взимать сервисные сборы (комиссию) за свои
      услуги. Сервисный сборы не возвращаются Пользователю, за исключением условий, предусмотренных
      настоящим Соглашением.
    </p>

    <p>
      3.10. Пользователь понимает и соглашается, что все действия, совершенные в рамках Сервиса с
      использованием подтвержденного им номера мобильного телефона (а также иных данных
      индивидуализирующих пользователя, пример: адрес электронной почты указанный в учетной записи,
      но не ограничиваясь этим), в том числе по безналичной оплате с использованием Привязанной
      банковской карты, считаются совершенными Пользователем.
    </p>

    <p>
      3.11. В случае несогласия Пользователя с фактом и/или суммой безналичной оплаты и по иным
      связанным с использованием Привязанной карты в рамках Сервиса вопросам Пользователь вправе
      обратиться к Правообладателю посредством функциональной возможности Сервиса или через форму
      обратной связи по адресу https:// content@nedvex.ru, в течение 14 дней со дня произведения
      безналичной оплаты или иных действий или событий, послуживших причиной обращения
      <br />
      <br />
      В случае если по результатам проверки по такому обращению Правообладатель принимает решение о
      возврате суммы безналичной оплаты полностью или частично, указанный возврат осуществляется на
      банковский счет банковской карты, с которой была произведена безналичная оплата. Порядок
      возврата денежных средств осуществляется с участием уполномоченного оператора по приему
      платежей или оператора электронных денежных средств, или иных участников расчетов,
      информационно-технологического взаимодействия, и регулируется правилами международных
      платежных систем, банков (в том числе банка-эмитента Привязанной карты) и других участников
      расчетов.
      <br />
      <br />В случае возврата денежных средств Пользователю, возврат осуществляется в течении 10
      (десяти) банковских дней с момента принятия решения о возврате Пользователю денежных средств
      Правообладателем.
    </p>

    <p>
      3.12. Правообладатель оставляет за собой право в любой момент потребовать от Пользователя
      подтверждения данных, указанных им в рамках Сервиса, в том числе данных Привязанной карты, и
      запросить, в связи с этим подтверждающие, непредоставление которых, по усмотрению
      Правообладатель может быть приравнено к предоставлению недостоверной информации и повлечь
      последствия, предусмотренные настоящим Соглашением.
    </p>

    <p>
      3.13. Правообладатель оставляет за собой право проводить для пользователей акции,
      предоставлять скидки и предлагать участие в программах лояльности. Информация о таких
      маркетинговых мероприятиях и их условиях размещаются Правообладателем в интерфейсе Сервиса.
    </p>

    <p>
      3.14. Правообладатель вправе в одностороннем порядке изменять действующий Список тарифов, о
      чем уведомляет Пользователя путем опубликования изменений за 3 (три) календарных дня до
      предполагаемой даты введения изменений в сети Интернет по сетевому адресу (доменному имени):{' '}
      <a href="https://app.nedvex.ru/">https://app.nedvex.ru/</a>.
    </p>

    <p>
      3.15. После получения Правообладателем вознаграждения, Правообладатель отображает в Аккаунте
      Пользователя информацию о:
    </p>

    <ul>
      <li>о доступном периоде (днях) использования сервиса;</li>
      <li>дополнительных условиях в рамках оплаченного тарифа;</li>
    </ul>

    <p>
      3.16. По предварительному письменному запросу Пользователя, направленному Правообладателю по
      его почтовому адресу, Правообладатель обязуется в течение 30 (Тридцати) рабочих дней с даты
      получения такого запроса направить Пользователю универсально-передаточный документ (УПД). При
      этом в таком запросе Пользователь должен быть конкретизирован срок, за который будет
      предоставляться необходимая информация, который не может превышать 1 (один) год,
      предшествующий дате направления Пользователем письменного запроса.
    </p>

    <p>
      3.17. В случае расторжения Соглашения Пользователем неистраченные денежные средства,
      остающиеся на дату расторжения, Пользователю не возвращаются.
    </p>

    <p>3.18. Услуги Сервиса НДС не облагаются (п.2, ст.346.11, гл.26.2 НК РФ).</p>

    <p>
      3.19. Расчет между Сторонами производится посредством функциональных возможностей Сервиса в
      рублях Российской Федерации.
    </p>

    <p>3.20. </p>

    <h3>4. Пределы использования Сервиса</h3>

    <p>
      4.1.{' '}
      <strong>
        Правообладатель предоставляет Пользователю следующие права использования Сервиса:
      </strong>
    </p>

    <p>
      4.1.1 право использования Программ для ЭВМ и (или) Базы данных NEDVEX в соответствии с их
      назначением, в том числе посредством удаленного доступа к ним через сеть Интернет. Право
      удаленного доступа Пользователя к Базе данных NEDVEX может осуществляться с воспроизведением
      Базы данных на серверах Правообладателя;
    </p>

    <p>
      4.1.2 право воспроизведения Программ для ЭВМ и Базы данных NEDVEX на персональных устройствах; Одновременно активным вход в сервис может быть только один с вебсайта и один с мобильного приложения;
    </p>

    <p>
      4.1.3. право извлечения данных об объектах недвижимого имущества из Базы данных NEDVEX и их
      последующего использования Пользователем в личных некоммерческих целях и/или с целью ведения
      деятельности, связанной с объектами недвижимого имущества, с обязательным указанием на Базу
      данных NEDVEX;
    </p>

    <p>
      4.2. <strong>Пользователь не вправе:</strong>
    </p>

    <p>
      4.2.1. в коммерческих целях воспроизводить, дублировать, копировать, продавать,
      распространять, осуществлять торговые операции и перепродавать Программы для ЭВМ и Базу данных
      NEDVEX и/или права их использования, за исключением случаев, когда такие действия были прямо
      разрешены Пользователю в соответствии с условиями настоящего Соглашения;
    </p>

    <p>
      4.2.2. дублировать, копировать, продавать, распространять, осуществлять торговые операции и
      перепродавать любые элементы дизайна или пользовательского интерфейса Программ для ЭВМ NEDVEX;
    </p>

    <p>
      4.2.3. перерабатывать Программы для ЭВМ и/или Базу данных NEDVEX, в пределах, прямо не
      предусмотренных Соглашением;
    </p>

    <p>4.2.4. регистрировать несколько Учетных записей в Сервисе;</p>

    <p>
      4.2.5. использовать Программы для ЭВМ и/или Базу данных NEDVEX иными способами, не
      предусмотренными настоящим Соглашением и выходящими за рамки обычного процесса
      функционирования Программ для ЭВМ, Базы данных и Сайта NEDVEX в целом.
    </p>

    <p>
      4.3. <strong>Правообладатель обязуется:</strong>
    </p>

    <p>
      4.3.1. предоставить Пользователю возможность реализации прав использования Сервиса в
      соответствии с условиями настоящего Соглашения и акцептованного Тарифа;
    </p>

    <p>
      4.3.2. публиковать в сети Интернет все изменения и/или дополнения к настоящему Соглашению не
      менее чем за 5 (пять) календарных дней до начала их действия;
    </p>

    <p>
      4.3.3. публиковать в сети Интернет все изменения и/или дополнения в Списке тарифов не менее
      чем за 3 (три) календарных дня до начала их действия;
    </p>

    <p>
      4.3.4. в случае изменения наименования Правообладателя, а также иных его реквизитов, включая
      банковские, незамедлительно уведомлять об этом Пользователя путем публикации новых реквизитов
      в сети Интернет по сетевому адресу (доменному имени){' '}
      <a href="https://app.nedvex.ru/">https://app.nedvex.ru/</a>.
    </p>

    <p>
      4.4. <strong>Правообладатель вправе:</strong>
    </p>

    <p>
      4.4.1. вносить изменения в Список тарифов и условия настоящего Соглашения в одностороннем
      порядке;
    </p>

    <p>
      4.4.2. в любое время ограничить возможность или отказать Пользователю в предоставлении
      возможности реализации прав использования Сервиса, в том числе путем удаления Учетной записи
      Пользователя или блокировки доступа к ней. Указанное в настоящем пункте право применяется
      Правообладателем без осуществления возврата денежных средств Пользователю в случае нарушения
      последним настоящего Соглашения, а также если:
    </p>

    <p>
      4.4.2.1. предоставление возможности реализации Пользователем прав использования Сервиса
      невозможно из-за физических, топографических или иных естественных препятствий;
    </p>

    <p>
      4.4.2.2. отсутствие уплаты за предоставление прав использования Сервиса, а также при наличии
      задолженности по оплате;
    </p>

    <p>
      4.4.2.3. Пользователь осуществляет реализацию прав использования Сервиса незаконно или
      незаконным способом, нанося тем самым ущерб Правообладателю и/или третьим лицам;
    </p>

    <p>
      4.4.2.4. Пользователь совершает иные действия, препятствующие, по мнению Правообладателя,
      нормальному функционированию Сервиса.
    </p>

    <p>4.4.3. по своему усмотрению осуществлять систематизацию Базы данных NEDVEX;</p>

    <p>
      4.4.4. в любое время изменять оформление Сервиса, его контент, список сервисов, изменять или
      дополнять используемые или хранящиеся в Сервисе программное обеспечение и другие объекты,
      любые серверные приложения в любое время с предварительным уведомлением или без такового;
    </p>

    <p>
      4.4.5. при необходимости отправлять Пользователям по электронной почте, посредством Сервиса и
      другими доступными способами сообщения, касающиеся использования Сервиса;
    </p>

    <p>
      4.4.6. изменять или удалять любой контент (содержащийся в Учетной записи Пользователя),
      который по усмотрению Правообладателя нарушает и/или может нарушать законодательство РФ,
      положения Соглашения и права третьих лиц, а также приостанавливать, ограничивать или
      прекращать доступ Пользователя ко всем или к любому из разделов Сервиса с предварительным
      уведомлением или без такового;
    </p>

    <p>
      4.4.7. Устанавливать дополнительные ограничения на использование Сервиса, а также изменять
      такие ограничения в любое время;
    </p>

    <p>
      4.4.8 Осуществлять рассылку Пользователю на электронную почту и по номеру мобильного телефона,
      указанные Пользователем в Учетной записи, а также с использованием иных средств коммуникации
      (в т.ч. но не ограничиваясь пуш-уведомления), доступных для связи с Пользователем, следующих
      видов сообщений:
    </p>

    <ol type="a">
      <li>
        служебные уведомления о событиях, связанных с функционированием Сервиса и Профиля
        Пользователя в целом, а также объявления по восстановлению пароля, напоминания по оплате (по
        мере возникновения необходимости уведомления Пользователя);
      </li>
      <li>информационных материалов из Базы данных в соответствии с подписками Пользователя;</li>
      <li>информационные сообщения — в том числе рекламного характера;</li>
    </ol>

    <p>
      Согласием Пользователя на получение данных рассылок является принятие условий (акцепт)
      настоящего Соглашения.
      <br />
      <br />
      Пользователь вправе отказаться от получения указанных рассылок, выполнив для этого действия,
      указанные в тексте получаемых от Правообладателя сообщений или обратившись к Правообладателю,
      через функциональные возможности сервиса.
      <br />
      <br />В течение 10 (десяти) рабочих дней после совершения Пользователем данных действий
      Правообладатель обязуется прекратить рассылку соответствующего вида сообщений в его адрес.
    </p>

    <p>
      4.4.9. при осуществлении технической поддержки Правообладатель вправе требовать от
      Пользователя подтверждения принадлежности ему Учетной записи путем предъявления требования о
      сообщении службе поддержки Правообладателя регистрационных данных Пользователя, а в случае
      несообщения таких данных — отказать обратившемуся в технической поддержке, если таковая
      требует совершения действий с конкретной Учетной записью Пользователя.
    </p>

    <p>
      4.4.10. пользоваться иными правами, предоставленными ему настоящим Соглашением и действующим
      законодательством Российской Федерации.
    </p>

    <h3>5. Права и обязанности Пользователя</h3>

    <p>5.1. Пользователь обязуется:</p>

    <p>
      5.1.1 ознакомиться с настоящим Соглашением и Списком тарифов до момента принятия условий
      (акцепта) настоящего Соглашения;
    </p>

    <p>
      5.1.2 выполнять требования, изложенные в настоящем Соглашении, всех его приложениях и
      дополнениях;
    </p>

    <p>
      5.1.3 своевременно, в соответствии с условиями настоящего Соглашения, выплачивать
      Правообладателю вознаграждение согласно акцептованному им Тарифу;
    </p>

    <p>
      5.1.4 не передавать полученные по настоящему Соглашению права использования Программ для ЭВМ и
      Базы данных NEDVEX какому-либо третьему лицу без предварительного письменного согласия
      Правообладателя;
    </p>

    <p>
      5.1.5 не применять при использовании Программ для ЭВМ и Базы данных NEDVEX каких-либо программ
      и/или систем автоматизации пользовательских действий, которые направлены на получение
      каких-либо преимуществ по сравнению со стандартными для остальных Пользователей условиями
      использования Программ для ЭВМ и Базы данных NEDVEX;
    </p>

    <p>
      5.1.6 сохранять конфиденциальность информации и коммерческую тайну, ставшую известной в
      результате исполнения настоящего Соглашения.
    </p>

    <p>5.1.7 информировать Правообладателя о несанкционированном доступе к Учетной записи</p>

    <p>5.1.8 регулярно осуществлять ознакомление с действующей редакцией настоящего Соглашения;</p>

    <p>
      5.1.9 не передавать полученные в соответствии с настоящим Соглашением права какому-либо
      третьему лицу без предварительного письменного согласия Правообладателя.
    </p>

    <p>
      5.1.10 при регистрации в Сервисе и в дальнейшем в случае изменения персональных данных
      Пользователя, вносить актуальную и достоверную информацию о персональных данных;
    </p>

    <p>5.2. Пользователю запрещается:</p>

    <p>
      5.2.1. Осуществлять действия, направленные на нарушение нормального функционирования Сервиса
    </p>

    <p>
      5.2.2. Загружать, хранить, публиковать, распространять и предоставлять доступ или иным образом
      использовать вирусы, трояны и другие вредоносные программы;
    </p>

    <p>
      5.2.3. Использовать без специального на то разрешения Правообладателя автоматизированные
      скрипты (программы) для сбора информации в Сервисе и/или взаимодействия с Сервисом и его
      функционалом;
    </p>

    <p>
      5.2.4. Любым способом, в том числе, но не ограничиваясь, путем обмана, злоупотребления
      доверием, взлома, пытаться получить доступ к Учетной записи или персональным данным других
      Пользователей
    </p>

    <p>5.3. Пользователь вправе:</p>

    <p>5.3.1. обращаться за технической поддержкой к Правообладателю.</p>

    <p>
      5.3.1. пользоваться правами, предоставленными ему настоящим Соглашением и действующим
      законодательством Российской Федерации.
    </p>

    <h3>6. ТЕРРИТОРИЯ И СРОК ДЕЙСТВИЯ НАСТОЯЩЕГО СОГЛАШЕНИЯ</h3>

    <p>
      6.1. Пользователь вправе использовать Сервис способами, описанными в настоящем Соглашении, на
      всей территории Российской Федерации, а также иных территориях, на которых они доступны
      посредствам удаленного доступа к ним через Сервисы Правообладателя, в том числе посредствам
      воспроизведения на персональных и (или) мобильных устройствах.
    </p>

    <p>
      6.2. Соглашение может быть расторгнуто Правообладателем в любое время в одностороннем порядке.
    </p>

    <p>
      6.2.1. Правообладатель имеет право отказать в предоставлении услуг до внесения Пользователем
      вознаграждение за использование Сервиса по Тарифу.
    </p>

    <p>
      6.2.2. Правообладатель имеет право в одностороннем порядке отказать Пользователю в
      предоставлении Услуги при условии надлежащего обоснования данного отказа в следующих случаях:
    </p>

    <ul>
      <li>предоставление Услуги может создать угрозу безопасности и здоровью людей;</li>
      <li>
        предоставление Услуги невозможно ввиду каких-либо технических, физических или иных
        естественных препятствий;
      </li>
      <li>
        на иных основаниях, предусмотренных настоящим Соглашением и действующим законодательством
        РФ.
      </li>
    </ul>

    <p>
      6.2.3. Правообладатель вправе в любое время посредством направления по электронной почте
      Пользователя (или иным способом предусмотренным настоящим Соглашением) и без объяснения причин
      расторгнуть настоящее Соглашение в одностороннем внесудебном порядке с немедленным
      прекращением доступа и возможности использовать всех Сервисов и без возмещения каких-либо
      затрат, убытков или возврата полученного по Соглашению, в случае:
    </p>

    <ul>
      <li>
        любого, в том числе однократного, нарушения Пользователем условий настоящего Соглашения или
        положений иных специальных документов и информационных сообщений, размещенных на Сайте
        NEDVEX, и регулирующих порядок и пределы использования Программ для ЭВМ и Базы данных
        NEDVEX;
      </li>
      <li>любых действий Пользователя, повлекших за собой сбой в работе Сервиса;</li>
      <li>
        полного или частичного прекращения обслуживания Программ для ЭВМ и Базы данных NEDVEX и
        прекращения к ним доступа (в том числе, закрытия Сайта Nedvex);
      </li>
      <li>использования получаемых услуг в незаконных целях.</li>
    </ul>

    <p>
      6.3. Моментом расторжения настоящего Соглашения будет считаться момент получения по
      электронной почте Пользователя соответствующего уведомления.
    </p>

    <p>
      6.4. Пользователь не имеет права требовать от Правообладателя выплаты ему денежного
      эквивалента неистраченных денежных средств, при расторжении Соглашения в одностороннем порядке
      по основаниям, указанным в настоящем Соглашении.
    </p>

    <p>
      6.5. Недействительность одного или нескольких положений настоящего Соглашения, признанная в
      установленном порядке вступившим в силу решением суда, не влечет для Сторон недействительности
      Соглашения в целом. В случае признания одного или нескольких положений Соглашения в
      установленном порядке недействительными, Стороны обязуются исполнять взятые на себя по
      Соглашению обязательства способом, максимально близким к таковому при заключенном и/или
      согласованном изменении Соглашения.
    </p>

    <p>
      6.6. Настоящее Соглашение и взаимоотношения его Сторон в связи с настоящим Соглашением и
      использованием Сервиса регулируются законодательством Российской Федерации.
    </p>

    <p>
      6.7. В отношении формы и способа заключения настоящего Соглашения также применяются нормы
      Гражданского Кодекса РФ, регулирующие порядок и условия заключения договора путем акцепта
      публичной оферты.
    </p>

    <p>
      6.8. Все споры и разногласия Сторон по настоящему Соглашению подлежат разрешению путем
      переписки и переговоров с использованием обязательного досудебного (претензионного) порядка. В
      случае если споры и разногласия не могут быть урегулированы путем переговоров, они передаются
      на рассмотрение Арбитражного суда Краснодарского края, а в случае, если Пользователь является
      физическим лицом – на рассмотрение Центрального районного суда города Сочи Краснодарского
      края.
    </p>

    <p>
      6.9. По всем вопросам, не урегулированным в настоящем Соглашении, Стороны руководствуются
      действующим законодательством Российской Федерации.
    </p>

    <h3>7. УСЛОВИЯ ИСПОЛЬЗОВАНИЯ ОТДЕЛЬНЫХ ФУНКЦИЙ СЕРВИСА</h3>

    <p>
      7.1. Выполнение некоторых функций Сервиса возможно только при наличии доступа к сети Интернет.
      Пользователь самостоятельно получает и оплачивает такой доступ на условиях и по тарифам своего
      оператора связи или провайдера доступа к сети Интернет.
    </p>

    <p>
      7.2. Для доступа к некоторым функциям Сервиса Пользователю необходимо пройти регистрацию в
      Сервисе в соответствии с условиями Пользовательского соглашения или авторизоваться с
      использованием ранее зарегистрированной учетной записи Пользователя.
      <br />
      <br />
      Отдельные функции Программы могут быть доступны Пользователю, не прошедшему процедуру
      авторизации.
    </p>

    <h3>8. ОТВЕТСТВЕННОСТЬ И ОГРАНИЧЕНИЯ</h3>

    <p>
      8.1. За невыполнение или ненадлежащее выполнение обязательств по настоящему Соглашению Стороны
      несут ответственность в соответствии с действующим законодательством Российской Федерации и
      положениями настоящего Соглашения.
    </p>

    <p>
      8.2. Программа предоставляется на условиях «как есть» (as is). Правообладатель не
      предоставляет никаких гарантий в отношении безошибочной и бесперебойной работы Программы или
      отдельных её компонентов и/или функций, соответствия Программы конкретным целям и ожиданиям
      Пользователя, а также не предоставляет никаких иных гарантий, прямо не указанных в настоящем
      Соглашении.
    </p>

    <p>
      8.3. Правообладатель не несет ответственности за ущерб любого рода, понесенный Пользователем
      при использовании Сервисов.
    </p>

    <p>
      8.4. В связи с использованием компьютерного и иного оборудования, каналов связи и/или программ
      для ЭВМ, принадлежащих третьим лицам, при оказании Услуг, Стороны соглашаются с тем, что
      Правообладатель не несет ответственность за любые задержки, прерывания, прямой и косвенный
      ущерб или потери, происходящие из за дефектов в любом электронном или механическом
      оборудовании и/или программах для ЭВМ, либо вследствие иных объективных технологических
      причин, а также в результате действий или бездействий третьих лиц, проблем при передаче данных
      или соединении, перебоев в электропитании, произошедшие не по вине Правообладателя.
    </p>

    <p>
      8.5. В случае нарушения Пользователем условий настоящего Соглашения Правообладатель вправе:
      (а) приостановить возможность реализации Пользователем тех или иных прав использования
      Программ для ЭВМ и Базы данных NEDVEX до момента устранения Пользователем допущенных нарушений
      и возмещения (компенсации) причиненных Правообладателю таким нарушением убытков в полном
      объеме и/или (б) расторгнуть настоящее Соглашение с направлением соответствующего уведомления
      Пользователю по адресу электронной почты Пользователя, указанной в личном кабинете. При
      расторжении настоящего Соглашения Правообладателем согласно настоящему пункту, Пользователь не
      имеет права требовать от Правообладателя выплаты денежного эквивалента неиспользованных
      денежных средств.
    </p>

    <p>
      8.6. Ответственность Правообладателя за неисполнение обязательств по настоящему Соглашению не
      может превышать размер ежемесячной оплаты Пользователем за Услуги по настоящему Соглашению.
    </p>

    <p>
      8.7. В случае нарушения Пользователем сроков оплаты Услуг, Правообладатель имеет право в
      одностороннем порядке приостановить оказание Услуг до момента выполнения Пользователем своих
      финансовых обязательств или заблокировать Учетную запись для входа в Личный кабинет.
    </p>

    <p>
      8.8. Ответственность за информацию, размещенную Пользователем в Сервисе, несет Пользователь,
      предоставивший данную информацию.
    </p>

    <p>
      8.9. Правообладатель не отвечает за достоверность персональных данных, предоставленных
      Пользователем.
    </p>

    <p>
      8.10. Пользователь несет всю ответственность согласно действующему законодательству РФ за
      последствия, возникшие в результате предоставления им недостоверной и (или) заведомо ложной
      регистрационной информации, и несет ответственность за нарушение прав и интересов других лиц в
      результате таких действий.
    </p>

    <p>
      8.11. При исполнении обязательств Правообладатель исходит из того, что Пользователем
      предоставлены полные, достоверные и актуальные сведения о субъекте персональных данных;
      субъект персональных данных предоставил согласие на обработку персональных данных (в т.ч.
      согласие на поручение обработки персональных данных и согласие на передачу персональных данных
      третьим лицам в соответствии с условиями настоящего Пользовательского соглашения.
    </p>

    <p>
      8.12. За исключением использования в объемах и способами, прямо предусмотренными настоящим
      Соглашением или законодательством РФ, Пользователь не имеет права изменять, декомпилировать,
      дизассемблировать, дешифровать и производить иные действия с объектным кодом Программы,
      имеющие целью получение информации о реализации алгоритмов, используемых в Программе,
      создавать производные произведения с использованием Программы, а также осуществлять (разрешать
      осуществлять) иное использование Программы, без письменного согласия Правообладателя.
    </p>

    <p>
      8.13. Пользователь не имеет права воспроизводить и распространять Программу в коммерческих
      целях (в том числе за плату), в том числе в составе сборников программных продуктов, без
      письменного согласия Правообладателя.
    </p>

    <p>
      8.14. Пользователь не имеет права распространять Программу в виде, отличном от того, в котором
      он ее получил, без письменного согласия Правообладателя.
    </p>

    <p>
      8.15. Программа должна использоваться (в том числе распространяться) под наименованием:
      «Nedvex». Пользователь не вправе изменять наименование Программы, изменять и/или удалять знак
      охраны авторского права (copyright notice) или иное указание на Правообладателя.
    </p>

    <p>
      8.16. Во всем остальном, что не предусмотрено Соглашением, Стороны будут руководствоваться
      действующим законодательством Российской Федерации
    </p>

    <h3>9. ОБРАБОТКА ПЕРСОНАЛЬНЫХ ДАННЫХ</h3>

    <p>
      9.1. Используя Сервис NEDVEX, отдельные Сервисы и/или регистрируясь на сайте Пользователь
      (физическое лицо или представитель юридического лица) тем самым свободно, своей волей и в
      своем интересе предоставляет свои персональные данные Правообладателю для их обработки.
    </p>

    <p>
      9.2. Под обработкой персональных данных понимаются предусмотренные Федеральным законом от
      27.07.2006 г. № 152-ФЗ «О персональных данных» действия или совокупность действий, совершаемых
      с использованием средств автоматизации или без использования таких средств с персональными
      данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление,
      изменение), извлечение, использование, передачу (распространение, предоставление, доступ)
      удаление, уничтожение персональных данных.
    </p>

    <p>
      9.3. Обработка персональных данных, предоставляемых Пользователем при регистрации Учетной
      записи, осуществляется в соответствии с условиями Политики обработки персональных данных,
      размещенных в сети Интернет по сетевому адресу (доменному имени):{' '}
      <a href="https://app.nedvex.ru/">https://app.nedvex.ru/</a>.
    </p>

    <h3>10. ФОРС–МАЖОР</h3>

    <p>
      10.1. Каждая из Сторон освобождается от ответственности за частичное или полное неисполнение
      обязательств по настоящему Соглашению, если она докажет, что оно явилось следствием
      обстоятельств непреодолимой силы, возникших после заключения Соглашения в результате событий
      чрезвычайного характера, таких как: пожар, взрыв, наводнение, землетрясение, забастовка,
      боевые действия, постановления Правительства или Президента Российской Федерации, федеральных
      и местных органов власти и других обстоятельств непреодолимой силы, которые Сторона не могла
      ни предвидеть, ни предотвратить, ни принять обстоятельства в расчет при заключении настоящего
      Соглашения.
    </p>

    <p>
      10.2. Освобождение от ответственности действует лишь на тот период, в течение которого
      существуют данные обстоятельства непреодолимой силы и их последствия.
    </p>

    <p>
      10.3. Сторона, ссылающаяся на обстоятельства непреодолимой силы, обязана незамедлительно
      информировать другую Сторону о наступлении и прекращении подобных обстоятельств и об их
      влиянии на возможность исполнения соответствующей Стороной обязательств по настоящему
      Соглашению в письменном виде.
    </p>

    <p>
      10.4. Действие непреодолимой силы отодвигает исполнение обязательств на срок, в течение
      которого имеет место такое действие. По прекращению действия обстоятельств непреодолимой силы
      Стороны обязаны немедленно приступить к исполнению своих обязательств.
    </p>

    <p>
      10.5. Наличие обстоятельств непреодолимой силы, их влияние и продолжительность действия должны
      быть подтверждены документально должностным лицом компетентного органа или представителем
      Стороны.
    </p>

    <h3>11. ИСКЛЮЧИТЕЛЬНОЕ ПРАВО</h3>

    <p>
      11.1. Пользователь признает, что программное обеспечение Сервиса, программные коды, установка
      и настройка которых производится для оказания Услуг по настоящему Соглашению, является
      собственной разработкой Правообладателя.
    </p>

    <p>
      11.2. Используя Сервис, Пользователь признает и соглашается с тем, что все содержимое Сервиса
      и структура содержимого Сервиса защищены авторским правом, правом на товарный знак и другими
      правами на результаты интеллектуальной деятельности, и что указанные права являются
      действительными и охраняются во всех формах, на всех носителях и в отношении всех технологий,
      как существующих в настоящее время, так и разработанных или созданных впоследствии. Никакие
      права на любое содержимое Сервиса, не переходят к Пользователю в результате использования
      Сервиса и заключения настоящего Соглашения.
    </p>

    <p>
      11.3. Правообладатель предоставляет Пользователю непередаваемое право использования Программы
      на территории Российской Федерации следующими способами:
    </p>

    <p>
      11.3.1. Применять Программу по прямому функциональному назначению, в целях чего произвести ее
      копирование и установку (воспроизведение) устройство(-ва) Пользователя. Пользователь вправе
      произвести установку Программы на неограниченное число устройств. При установке на устройство
      каждой копии Программы присваивается индивидуальный номер, который автоматически сообщается
      Правообладателю.
    </p>

    <p>11.3.2. Воспроизводить и распространять Программу в некоммерческих целях (безвозмездно).</p>

    <p>
      11.4. Пользователь не вправе: модифицировать программное обеспечение, Сервис, программные коды
      и производить их обратное проектирование, под которым подразумевается декомпилирование
      программного обеспечения с целью определения структуры, конструкции, концепции и методологии
      по предоставлению Услуг, копировать и/или распространять какие-либо объекты интеллектуальных
      прав, размещенных в Сервисе (включая пользовательские интерфейсы, визуальные интерфейсы,
      названия товарных знаков, логотипы, базы данных, фотографии, планировки, тексты, а также
      дизайн, структуру, выбор, координацию, внешний вид, общий стиль и расположение данного
      содержания, входящего в состав Сервиса), кроме случаев, когда такая функция прямо
      предусмотрена (разрешена) в Сервисе, копировать, либо иным способом использовать программную
      часть Сервиса, а также его дизайн.
    </p>

    <p>
      11.5. Пользователь вправе только использовать функционал предоставляемого Правообладателем
      программного обеспечения, Сервиса по его прямому назначению для целей настоящего Соглашения.
    </p>

    <p>
      11.6. В случае нарушения Пользователем прав Правообладателя, указанных в настоящем разделе
      Соглашения, Пользователь несет ответственность в соответствии с действующим законодательством
      Российской Федерации.
    </p>

    <h3>12. ИНФОРМАЦИОННАЯ БЕЗОПАСНОСТЬ СЕРВИСА</h3>

    <p>
      12.1. Используя Сервис, Пользователь обязуется не нарушать информационную безопасность
      Сервиса, что включает в себя:
    </p>

    <p>
      12.1.1. Доступ к любой информации, не предназначенной для использования Пользователем или вход
      в Сервис под логином (номером мобильного телефона), не принадлежащем данному Пользователю;
    </p>

    <p>
      12.1.2. Попытки проверить уязвимость системы безопасности Сервиса, нарушение процедуры
      регистрации и авторизации без разрешения Сервиса;
    </p>

    <p>
      12.1.3. Попытки создать помехи в использовании Сервиса другим Пользователям, что включает в
      себя распространение вредоносных программ, удаление, искажение данных, постоянную рассылку
      повторяющейся информации, пересылку электронной почты через сервер сайта, одновременную
      отправку большого количества электронной почты и/или запросов к Сервису с целью намеренно
      вывести сервер сайта из строя и тому подобные действия, выходящие за рамки нормального
      целевого использования Сервиса, и способные умышленно или по неосторожности повлечь сбои в его
      работе.
    </p>

    <p>
      12.2. Нарушение безопасности системы или компьютерной сети влечет за собой гражданскую и
      уголовную ответственность. Правообладатель будет расследовать все случаи возможного нарушения
      безопасности со стороны Пользователей в сотрудничестве с компетентными органами с целью
      пресечения подобной злонамеренной деятельности.
    </p>

    <p>
      12.3. Правообладатель прилагает все возможные усилия для того, чтобы избежать
      несанкционированного использования персональных данных Пользователей.
    </p>

    <p>
      12.4. Правообладатель не несет ответственности за возможное использование персональных данных
      Пользователей, произошедшее из-за:
    </p>

    <p>
      12.4.1. Технических проблем, возникших в программном обеспечении, серверах или компьютерных
      сетях, находящихся вне контроля Правообладателя;
    </p>

    <p>
      12.4.2. Перебоев в работе Сервиса, связанных с намеренным или ненамеренным использованием
      Сервиса не по назначению третьими лицами;
    </p>

    <p>12.4.3. Передачи паролей или информации с Сервиса Пользователями другим лицам.</p>

    <p>
      12.5. Правообладатель не отвечает за возможное нецелевое использование информации с Сервиса
      Пользователями или иными лицами, которое произошло без уведомления Правообладателя с
      нарушением или без информационной безопасности Сервиса.
    </p>

    <h3>13. ОБНОВЛЕНИЯ/НОВЫЕ ВЕРСИИ</h3>

    <p>
      13.1. Действие настоящего Соглашения распространяется на все последующие обновления/новые
      версии составных частей Сервиса. Соглашаясь с установкой обновления/новой версии Программы,
      Пользователь принимает условия настоящего Соглашения для соответствующих обновлений/новых
      версий Программы, если обновление/установка новой версии Программы не сопровождается иным
      соглашением.
    </p>

    <p>
      13.2. В состав Сервиса в качестве отдельных ее компонентов входит стороннее программное
      обеспечение – Яндекс. Метрика и Google Analytics. Условия работы стороннего программного
      обеспечения расположены по адресу{' '}
      <a href="https://yandex.ru/legal/metrica_termsofuse/">
        https://yandex.ru/legal/metrica_termsofuse/
      </a>{' '}
      и по адресу{' '}
      <a href="https://support.google.com/analytics/answer/4597324?hl=ru">
        https://support.google.com/analytics/answer/4597324?hl=ru
      </a>
      .
    </p>

    <h3>14. ИНЫЕ ПОЛОЖЕНИЯ</h3>

    <p>
      14.1. Правообладатель не дает гарантий и не несет ответственности за несоответствие оказанных
      Услуг конкретным целям и/или ожиданиям Пользователя. Правообладатель имеет право в
      одностороннем порядке лишить Пользователя пробного бесплатного периода, предварительно
      уведомив его об этом посредством Сервиса или контактной информации, оставленной о себе в
      Личном кабинете.
    </p>

    <p>
      14.2. Пользователь предупрежден и принимает условие, что все запросы обрабатываются
      Правообладателем в порядке очереди, Пользователь обязан учитывать это условие при отправке
      запроса.
    </p>

    <p>
      14.3. По вопросам, связанным с исполнением настоящего Cоглашения, необходимо обращаться к
      Правообладателю. Все обращения должны направляться на адрес электронной почты либо на почтовый
      адрес Правообладателя, указанные ниже. Функционалом Сервиса также могут быть предусмотрены
      иные способы направления Пользователем обращений к Правообладателю.
    </p>

    <p>
      14.4. Настоящее Соглашение регулируется и толкуется в соответствии с законодательством
      Российской Федерации. Вопросы, не урегулированные настоящим Соглашением, подлежат разрешению в
      соответствии с законодательством Российской Федерации.
    </p>

    <p>
      14.5. Настоящее Соглашение, составлено на русском языке, является публичным договором,
      содержит все существенные условия договора оказания услуг посредством Сервиса и адресована
      неопределенному кругу лиц.
    </p>

    <p>14.6. Соглашение в данной редакции вступает в силу с 01 сентября 2024 года.</p>

    <h3>ПРАВООБЛАДАТЕЛЬ:</h3>

    <p>
      ООО «НЕДВЕКС»
      <br />
      ИНН 2318043183, КПП 231801001, ОГРН: 1162366056830
      <br />
      Юридический адрес: 354207, Краснодарский край, г. Сочи, Лазаревский район, ул. Летняя, стр.
      №15/2
      <br />
      Почтовый адрес: 354000, Краснодарский край, г. Сочи, Центральный район, пер. Морской, д.1/1а
      <br />
      <br />
      Банковские реквизиты:
      <br />
      р/сч 40702810012250003417
      <br />
      в Филиале Южный ПАО Банка «ФК Открытие»
      <br />
      БИК 046015061
      <br />
      к/сч 30101810560150000061
      <br />
    </p>

    <p>
      E-mail: <a href="mailto: https://content@nedvex.ru/">content@nedvex.ru</a>
    </p>
  </div>
);

export default UserAgreement;



// WEBPACK FOOTER //
// ./src/containers/Landing/UserAgreement.jsx